import React, { Children, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { Stack } from '@mui/material';
import { Notifications, ShoppingCart } from '@mui/icons-material';

import IconNav from './IconNav';

const MenuNav = ({ isSamePathname }) => {
  const { isOnlinePath, isPracticePath, isOnCampusPath } = isSamePathname || {};

  const cart = useSelector((state) => state.cart);
  const notification = useSelector((state) => state.notification);

  const menus = useMemo(
    () => [
      {
        value: notification?.filteredNotifications?.length,
        icon: <Notifications />,
        path: '/notification',
      },
      {
        value: cart?.carts?.length,
        icon: <ShoppingCart />,
        action: () => {
          window.location.href = `${window.location.origin}/cart`;
        },
        notShow: isOnlinePath || isPracticePath || isOnCampusPath,
      },
    ],
    [
      isOnlinePath,
      isOnCampusPath,
      isPracticePath,
      cart?.carts?.length,
      notification?.filteredNotifications?.length,
    ],
  );

  return (
    <Stack direction="row" alignItems="center" spacing={2.5}>
      {Children.toArray(
        menus.map((menu) => {
          if (menu.notShow) {
            return null;
          }

          if (menu.action) {
            return (
              <IconNav value={menu.value} onClick={menu.action}>
                {menu.icon}
              </IconNav>
            );
          }
          return (
            <Link to={menu.path}>
              <IconNav value={menu.value}>{menu.icon}</IconNav>
            </Link>
          );
        }),
      )}
    </Stack>
  );
};

export default MenuNav;
